import React, { useState, useEffect } from "react";
import {
    Layout,
    theme,
    ConfigProvider,
    Row,
    Form,
    Typography,
    Col,
    Table,
    Input,
    Divider,
    Spin,
    Card,
    Breadcrumb,
    Collapse,
    Checkbox,
    Select,
    DatePicker
} from "antd";
import menuItems from "../../../config/data/menus.json";
import FloatButtonComp from "../../../components/FloatButtonComp";
import { useNavigate, Link } from "react-router-dom";
import "../../../assets/styles/DatePicker.css";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";
import MainLayout from "../../../components/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
// import FormBranchVault from "./components/FormBranchVaultLayout";



const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;
const { Search, TextArea } = Input;
const Option = Select;
let selectedSignatries = [];

function MainPage(props) {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);



    useEffect(() => {
        // Simulate an API call or data fetching
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);

    function onCancel() {
        navigate("/sya0700", { replace: false });
    }

    const onSubmit = (values) => {
        console.log("Success:", values);
    };


    return (
        <div>
            <Card
                style={{
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                    marginBottom: 25,
                }}>
                <Col>
                    <Row style={{ marginBottom: 0, marginTop: 0 }}>
                        <Title level={2} style={{ margin: 0 }}>
                            {props.titleOfPage}
                        </Title>
                    </Row>
                    <Breadcrumb style={{ marginBottom: 0 }}>
                        <BreadcrumbItem>
                            <Link to="/dashboard">Home</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <Link to="/sya0700">Holidays</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <Text>Add Holiday</Text>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Col>

            </Card>
            <div>
                <Spin spinning={loading}>
                    <Form layout="vertical" style={{ paddingTop: 20 }} onFinish={onSubmit}>

                        <Card
                            style={{
                                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                                borderRadius: 20,
                            }}

                            title={"Create Holiday"}
                        >
                            <Card
                                style={{
                                    marginBottom: "2%",
                                    boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                                }}
                            >
                                <Row style={{ justifyContent: "space-between" }}>

                                    <Col span={12}>
                                        <Form.Item
                                            name="name"
                                            label={<Text strong>Name</Text>}
                                            rules={[{
                                                required: true,
                                                message: "Required Field"
                                            }]}>
                                            <Input style={{ width: "30vh" }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row style={{ justifyContent: "space-between" }}>

                                    <Col span={12}>
                                        <Form.Item
                                            name="startDate"
                                            label={<Text strong>Start date</Text>}
                                            rules={[{
                                                required: true,
                                                message: "Required Field"
                                            }]}>
                                            <DatePicker style={{ width: "30vh" }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            name="endDate"
                                            rules={[{
                                                required: true,
                                                message: "Required Field"
                                            }]}
                                            label={<Text strong>End Date</Text>}
                                        >
                                            <DatePicker style={{ width: "30vh" }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row style={{ justifyContent: "space-between" }}>

                                    <Col span={12}>
                                        <Form.Item
                                            name="repayType"
                                            label={<Text strong>Repayment Scheduling Type</Text>}
                                            rules={[{
                                                required: true,
                                                message: "Required Field"
                                            }]}>
                                            <Select
                                                showSearch
                                                placeholder={"Select Option"}
                                                style={{ width: "30vh" }}
                                                options={[
                                                    { value: "specifiedDate", label: "Reschedule to specified date" },
                                                    { value: "nextPayDate", label: "Reschedule to next payment date" },
                                                ]}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            name="repayTo"
                                            label={<Text strong>Repayment scheduled to</Text>}
                                        >
                                            <Input style={{ width: "30vh" }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row style={{ justifyContent: "space-between" }}>

                                    <Col span={12}>
                                        <Form.Item
                                            label={<Text strong>Description</Text>}
                                            name="desc"
                                            style={{ width: "30vh" }}
                                        >
                                            <TextArea ></TextArea>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            name="appBranches"
                                            rules={[{
                                                required: true,
                                                message: "Required Field"
                                            }]}
                                            label={<Text strong>Applicable branches</Text>}
                                        >
                                            <Select
                                                showSearch
                                                placeholder={"Select Option"}
                                                style={{ width: "30vh" }}
                                                options={[
                                                    { value: "headOffice", label: "Head Office" },
                                                    { value: "branchOffice", label: "Branch Office" },
                                                    { value: "testOffice", label: "Test Office" },
                                                ]}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>

                            </Card>
                            <Form.Item>
                                <Row>
                                    <CustomButton
                                        content="Submit"
                                        style={{
                                            width: "10%",
                                            marginLeft: "auto",
                                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                        }}
                                        htmlType="submit"
                                        backgroundColor="#92428B"
                                        colorText="white"
                                        hoverBackground="#AD4EA7"
                                    />
                                    <CustomButton
                                        content="Cancel"
                                        style={{
                                            width: "10%",
                                            marginLeft: "1%",
                                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                        }}
                                        backgroundColor="#fff"
                                        colorText="black"
                                        hoverBackground="#F5F5F5"
                                        onClick={onCancel}
                                    />
                                </Row>
                            </Form.Item>
                        </Card>
                    </Form>
                </Spin>
            </div>
        </div>
    )
}


const AddSYA0700 = () => {
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);
    const [selectedKey, setSelectedKey] = useState("/cst0100");
    const [switchLabel, setSwitchLabel] = useState("Dark Mode");
    const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
    const [menuBG, setMenuBG] = useState("#2F172D");
    const [searchColorBgContainer, setSearchColorBgContainer] =
        useState("#3B2639");
    const [menuTheme, setMenuTheme] = useState("dark");
    const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
    const [logoDimensions, setLogoDimensions] = useState(100);
    const [menuSearchBarState, setMenuSearchBarState] = useState(false);
    const [menuSearchIconState, setMenuSearchIconState] = useState(true);
    const [switchLabelState, setSwitchLabelState] = useState(false);

    function onSwitchClick() {
        if (switchLabel === "Dark Mode") {
            setSwitchLabel("Light Mode");
            setMenuBG("#fff");
            setSearchColorBgContainer("#f7f8fa");
            setSwitchLabelColor("#8c8f9f");
            setMenuTheme("light");
        } else {
            setSwitchLabelColor("#aeaeae");
            setSwitchLabel("Dark Mode");
            setMenuBG("#2F172D");
            setSearchColorBgContainer("#3B2639");
            setMenuTheme("dark");
        }
    }

    function onMenuSelect(menuItems) {
        // console.log(menuItems.key);
        setSelectedKey(menuItems.key);
        navigate(menuItems.key, { replace: false });
    }

    useEffect(() => {
        if (collapsed === true) {
            setLeftLayoutMargin(71);
            setLogoDimensions(50);
            setMenuSearchBarState(true);
            setMenuSearchIconState(false);
            setSwitchLabelState(true);
        } else {
            setLeftLayoutMargin(190);
            setLogoDimensions(100);
            setMenuSearchBarState(false);
            setMenuSearchIconState(true);
            setSwitchLabelState(false);
        }
    });

    const {
        token: { colorBgContainer },
    } = theme.useToken();
    return (
        <ConfigProvider
            theme={{
                components: {
                    Layout: {
                        siderBg: menuBG,
                    },
                    Menu: {
                        darkItemBg: menuBG,
                        darkSubMenuItemBg: "#241223",
                    },
                },
            }}
        >
            <MainLayout
                collapsed={collapsed}
                searchColorBgContainer={searchColorBgContainer}
                theme={menuTheme}
                defaultSelectedKeys={selectedKey}
                items={menuItems}
                onClick={onMenuSelect}
                switchLabel={switchLabel}
                onSwitchClick={onSwitchClick}
                switchLabelColor={switchLabelColor}
                logoDimensions={logoDimensions}
                menuSearchBarState={menuSearchBarState}
                menuSearchIconState={menuSearchIconState}
                switchLabelState={switchLabelState}
                setCollapsed={setCollapsed}
                leftLayoutMargin={leftLayoutMargin}
                colorBgContainer={colorBgContainer}
            >
                <MainPage titleOfPage={"Add Holiday"} />
            </MainLayout>
        </ConfigProvider>
    );
};
export default AddSYA0700;



